var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconEreignis = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M44.204 38.122 33.36 27.276l-1.204 1.975-1.316-4.495-4.817-4.817-2.724 6.703-1.518-.834-4.226 11.271.123 3.442-1.553.373-3.24 8.637a1.274 1.274 0 0 0 .297 1.364 1.27 1.27 0 0 0 1.365.297l6.833-2.562.262-1.6 2.438.588 5.302-1.989v-1.982l2.774.942 5.141-1.928.54-1.538 2.14.533 3.769-1.413c.88-.33 1.12-1.46.46-2.121Z",
  fill: "#405B73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m39.976 41.656-2.68 1.005a23.213 23.213 0 0 1-5.73-10.15 23.346 23.346 0 0 1-.727-7.755l2.52 2.52c.038 1.044.155 2.079.348 3.094a20.634 20.634 0 0 0 6.27 11.286ZM32.155 44.59l-2.774 1.04a23.242 23.242 0 0 1-7.6-19.822l2.053-5.476a1.292 1.292 0 0 1 2.121-.46l.067.067c-2.601 5.868-2.29 12.333.422 17.694a20.68 20.68 0 0 0 5.711 6.956ZM24.078 47.618l-2.7 1.012a22.952 22.952 0 0 1-2.738-3.193 23.07 23.07 0 0 1-2.517-4.542v-.001l1.431-3.814a20.303 20.303 0 0 0 2.923 6.52 20.426 20.426 0 0 0 3.601 4.018Z",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.457 24.004a1.29 1.29 0 0 1 0-1.825c4.855-4.855 3.354-9.582 3.339-9.63a1.29 1.29 0 0 1 2.448-.816c.085.255 2.009 6.3-3.962 12.27a1.29 1.29 0 0 1-1.825 0ZM40.751 28.62a1.29 1.29 0 0 0 1.825 0c4.855-4.855 9.582-3.355 9.63-3.339a1.29 1.29 0 0 0 .815-2.448c-.254-.085-6.3-2.009-12.27 3.961a1.29 1.29 0 0 0 0 1.825Z",
  fill: "#F4CC54"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 45.974,
  cy: 13.956,
  r: 1.29,
  fill: "#F4CC54"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 31.041,
  cy: 10.757,
  r: 1.29,
  fill: "#F4CC54"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 44.576,
  cy: 20.816,
  r: 1.29,
  fill: "#405B73"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 45.574,
  cy: 32.712,
  r: 1.29,
  fill: "#F4CC54"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.377,
  cy: 18.593,
  r: 1.29,
  fill: "#405B73"
})));
export default SvgIconEreignis;